// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Restaumatic_Menu_Promotions from "../Restaumatic.Menu.Promotions/index.js";
import * as Restaumatic_Menu_Types_Id from "../Restaumatic.Menu.Types.Id/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
var MenuQuery = function (x) {
    return x;
};
var runMenuQuery = function (menu) {
    return function (v) {
        return Control_Monad_Reader_Trans.runReaderT(v)(menu);
    };
};
var monadMenuQuery = /* #__PURE__ */ Control_Monad_Reader_Trans.monadReaderT(Data_Either.monadEither);
var menuError = /* #__PURE__ */ (function () {
    var $86 = Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(Data_Either.monadEither);
    return function ($87) {
        return MenuQuery($86(Data_Either.Left.create($87)));
    };
})();
var functorMenuQuery = /* #__PURE__ */ Control_Monad_Reader_Trans.functorReaderT(Data_Either.functorEither);
var context = function (msg) {
    return function (v) {
        return Control_Monad_Reader_Trans.mapReaderT(Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(function (x) {
            return msg(Data_Unit.unit) + (": " + x);
        }))(v);
    };
};
var bindMenuQuery = /* #__PURE__ */ Control_Monad_Reader_Trans.bindReaderT(Data_Either.bindEither);
var askMenu = /* #__PURE__ */ Control_Monad_Reader_Class.ask(/* #__PURE__ */ Control_Monad_Reader_Trans.monadAskReaderT(Data_Either.monadEither));
var applyMenuQuery = /* #__PURE__ */ Control_Monad_Reader_Trans.applyReaderT(Data_Either.applyEither);
var applicativeMenuQuery = /* #__PURE__ */ Control_Monad_Reader_Trans.applicativeReaderT(Data_Either.applicativeEither);
var orError = function (v) {
    return function (v1) {
        if (v instanceof Data_Maybe.Just) {
            return Control_Applicative.pure(applicativeMenuQuery)(v.value0);
        };
        if (v instanceof Data_Maybe.Nothing) {
            return menuError(v1(Data_Unit.unit));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.Query (line 55, column 1 - line 55, column 67): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var findDish = function (id) {
    return Control_Bind.bind(bindMenuQuery)(askMenu)(function (v) {
        return orError(Data_Map_Internal.lookup(Restaumatic_Menu_Types_Id.ordDishId)(id)(v.dishes))(function (v1) {
            return "Dish not found: " + Data_Show.show(Restaumatic_Menu_Types_Id.showDishId)(id);
        });
    });
};
var findMainDish = findDish;
var findDishGroup = function (id) {
    return Control_Bind.bind(bindMenuQuery)(askMenu)(function (v) {
        return orError(Data_Map_Internal.lookup(Restaumatic_Menu_Types_Id.ordDishGroupId)(id)(v.dishGroups))(function (v1) {
            return "DishGroup not found: " + Data_Show.show(Restaumatic_Menu_Types_Id.showDishGroupId)(id);
        });
    });
};
var findDishGroupName = /* #__PURE__ */ (function () {
    var $88 = Data_Functor.map(functorMenuQuery)((function () {
        var $90 = Data_Newtype.unwrap();
        return function ($91) {
            return (function (v) {
                return v.name;
            })($90($91));
        };
    })());
    return function ($89) {
        return $88(findDishGroup($89));
    };
})();
var findDrink = function (id) {
    return Control_Bind.bind(bindMenuQuery)(askMenu)(function (v) {
        return orError(Data_Map_Internal.lookup(Restaumatic_Menu_Types_Id.ordDrinkId)(id)(v.drinks))(function (v1) {
            return "Drink not found: " + Data_Show.show(Restaumatic_Menu_Types_Id.showDrinkId)(id);
        });
    });
};
var findDrinkPrice = function (v) {
    return function (size) {
        return orError(Data_Map_Internal.lookup(Restaumatic_Menu_Types_Id.ordDrinkSize)(size)(v.priceBySize))(function (v1) {
            return "DrinkSize not found: " + Data_Show.show(Restaumatic_Menu_Types_Id.showDrinkSize)(size);
        });
    };
};
var findDrinkSizeName = function (size) {
    return Control_Bind.bind(bindMenuQuery)(askMenu)(function (v) {
        return orError(Data_Map_Internal.lookup(Restaumatic_Menu_Types_Id.ordDrinkSize)(size)(v.drinkSizeNames))(function (v1) {
            return "DrinkSize not found: " + Data_Show.show(Restaumatic_Menu_Types_Id.showDrinkSize)(size);
        });
    });
};
var findFODPromotion = /* #__PURE__ */ (function () {
    var isFod = function ($92) {
        return Restaumatic_PromotionsEngine_Promotions_Promotion.isFirstOrderPromotion(Restaumatic_Menu_Promotions.toEnginePromotion($92));
    };
    return Control_Bind.bind(bindMenuQuery)(askMenu)(function (v) {
        return orError(Data_Foldable.find(Data_Map_Internal.foldableMap)(isFod)(v.promotions))(function (v1) {
            return "New FOD not found";
        });
    });
})();
var findPan = function (id) {
    return Control_Bind.bind(bindMenuQuery)(askMenu)(function (v) {
        return orError(Data_Map_Internal.lookup(Restaumatic_Menu_Types_Id.ordPanType)(id)(v.panTypes))(function (v1) {
            return "Pan not found: " + Data_Show.show(Restaumatic_Menu_Types_Id.showPanType)(id);
        });
    });
};
var findPanPrice = function (v) {
    return function (size) {
        return context(function (v1) {
            return "findPanPrice " + (Data_Show.show(Restaumatic_Menu_Types_Id.showPanType)(v.type) + (" " + Data_Show.show(Restaumatic_Menu_Types_Id.showPizzaSize)(size)));
        })(orError(Data_Map_Internal.lookup(Restaumatic_Menu_Types_Id.ordPizzaSize)(size)(v.priceBySize))(function (v1) {
            return "Not found";
        }));
    };
};
var findPizza = function (id) {
    return context(function (v) {
        return "findPizza " + Data_Show.show(Restaumatic_Menu_Types_Id.showPizzaId)(id);
    })(Control_Bind.bind(bindMenuQuery)(askMenu)(function (v) {
        return orError(Data_Map_Internal.lookup(Restaumatic_Menu_Types_Id.ordPizzaId)(id)(v.pizzas))(function (v1) {
            return "Pizza not found";
        });
    }));
};
var findPizzaPrice = function (v) {
    return function (size) {
        return context(function (v1) {
            return "findPizzaPrice " + (Data_Show.show(Data_Show.showString)(v.name) + (" " + Data_Show.show(Restaumatic_Menu_Types_Id.showPizzaSize)(size)));
        })(orError(Data_Map_Internal.lookup(Restaumatic_Menu_Types_Id.ordPizzaSize)(size)(v.priceBySize))(function (v1) {
            return "Pizza price not found";
        }));
    };
};
var findPromotion = function (id) {
    return Control_Bind.bind(bindMenuQuery)(askMenu)(function (v) {
        return orError(Data_Map_Internal.lookup(Restaumatic_Promotions_Types_Id.ordPromotionId)(id)(v.promotions))(function (v1) {
            return "New promotion not found: " + Data_Show.show(Restaumatic_Promotions_Types_Id.showPromotionId)(id);
        });
    });
};
var findSideDish = function (sideId) {
    return function (sideDishId) {
        var findInDish = function (v) {
            return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Foldable.find(Data_Foldable.foldableArray)(function (v1) {
                return Data_Eq.eq(Restaumatic_Menu_Types_Id.eqSideId)(v1.id)(sideId);
            })(v.sides))(function (v1) {
                return Data_Foldable.find(Data_Foldable.foldableArray)(function (v2) {
                    return Data_Eq.eq(Restaumatic_Menu_Types_Id.eqDishId)(v2.id)(sideDishId);
                })(v1.dishes);
            });
        };
        return Control_Bind.bind(bindMenuQuery)(askMenu)(function (v) {
            return orError(Data_Foldable.findMap(Data_Map_Internal.foldableMap)(findInDish)(v.dishes))(function (v1) {
                return "Side Dish not found: " + (Data_Show.show(Restaumatic_Menu_Types_Id.showSideId)(sideId) + (", " + Data_Show.show(Restaumatic_Menu_Types_Id.showDishId)(sideDishId)));
            });
        });
    };
};
var findSizeName = function (size) {
    return context(function (v) {
        return "findSizeName " + Data_Show.show(Restaumatic_Menu_Types_Id.showPizzaSize)(size);
    })(Control_Bind.bind(bindMenuQuery)(askMenu)(function (v) {
        return Data_Functor.map(functorMenuQuery)((function () {
            var $93 = Data_Newtype.unwrap();
            return function ($94) {
                return (function (v1) {
                    return v1.name;
                })($93($94));
            };
        })())(orError(Data_Map_Internal.lookup(Restaumatic_Menu_Types_Id.ordPizzaSize)(size)(v.sizeNames))(function (v1) {
            return "PizzaSize not found: " + Data_Show.show(Restaumatic_Menu_Types_Id.showPizzaSize)(size);
        }));
    }));
};
var findTopping = function (id) {
    return context(function (v) {
        return "findTopping " + Data_Show.show(Restaumatic_Menu_Types_Id.showToppingId)(id);
    })(Control_Bind.bind(bindMenuQuery)(askMenu)(function (v) {
        return orError(Data_Map_Internal.lookup(Restaumatic_Menu_Types_Id.ordToppingId)(id)(v.toppings))(function (v1) {
            return "Topping not found";
        });
    }));
};
var findToppingPrice = function (v) {
    return function (size) {
        return orError(Data_Map_Internal.lookup(Restaumatic_Menu_Types_Id.ordPizzaSize)(size)(v.priceBySize))(function (v1) {
            return "PizzaSize not found: " + Data_Show.show(Restaumatic_Menu_Types_Id.showPizzaSize)(size);
        });
    };
};
export {
    findPizza,
    findPizzaPrice,
    findTopping,
    findToppingPrice,
    findPan,
    findSizeName,
    findMainDish,
    findSideDish,
    findDrink,
    findDrinkSizeName,
    findDrinkPrice,
    findPanPrice,
    findPromotion,
    findFODPromotion,
    askMenu,
    runMenuQuery,
    orError,
    menuError,
    functorMenuQuery,
    applyMenuQuery,
    applicativeMenuQuery,
    bindMenuQuery,
    monadMenuQuery
};
//# sourceMappingURL=index.js.map
